$('.inspiration-loop__slider').each(function(key) {

    var sliderIdName = 'inspoSlider' + key;
    var sliderNavIdName = 'inspoSliderNav' + key;
  
    this.id = sliderIdName;
    $('.inspiration-loop__buttons')[key].id = sliderNavIdName;
  
    var sliderId = '#' + sliderIdName;

    var prevButton = document.querySelectorAll('.inspiration-loop__prev-button');
    var nextButton = document.querySelectorAll('.inspiration-loop__next-button');
  
    $(sliderId).slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: prevButton[key],
        nextArrow: nextButton[key],
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                prevArrow: prevButton[key],
                nextArrow: nextButton[key],
              },
            },
        ],
    });
});

